import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const CommonButton = styled.button.attrs({ type: 'button' })`
  width: 100%;
  position: relative;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  padding: 5px 10px 5px 40px;
  text-align: left;
  border-radius: 4px;

  background: transparent;
  transition: background 0.3s;

  &:hover {
    background: ${Colors.GS0};
  }
`

export const commonIndicatorStyles = css`
  position: absolute;
  content: '';
  width: 1px;
  background: ${Colors.GS550};
  left: 16px;
`

export const CategoryButton = styled(CommonButton)<{ active: boolean }>`
  &::before {
    ${commonIndicatorStyles};
    display: none;
    height: 8px;
    bottom: -4px;
  }

  ${({ active }) =>
    active &&
    css`
      &::before {
        display: block;
      }
    `}
`

export const Emoji = styled.div`
  position: absolute;
  left: 8px;
  font-size: 20px;
`
